import { render, staticRenderFns } from "./DocumentAttachmentColumn.vue?vue&type=template&id=706d74de&scoped=true"
import script from "./DocumentAttachmentColumn.vue?vue&type=script&lang=js"
export * from "./DocumentAttachmentColumn.vue?vue&type=script&lang=js"
import style0 from "./DocumentAttachmentColumn.vue?vue&type=style&index=0&id=706d74de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d74de",
  null
  
)

export default component.exports